module.exports = __webpack_public_path__ + "image/header.5ac568d.jpg";